import React, { useEffect } from 'react';
import { useField } from 'formik';
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input';
import PhoneField from './index.js';

import './index.sass';

const FormikPhoneField = ({ className, name = 'customerPhone', error, ...rest}) => {
    const validate = value => {
        if (value === '' || typeof(value) === 'undefined') {
            return 'Заполните поле'
        }
        if (!isValidPhoneNumber(value)) {
            return 'Неверный формат телефона';
        }
        return undefined;
    };

    const [ field, meta, helpers ] = useField({name, validate});
    const { setValue } = helpers;

    useEffect(() => {
        helpers.setError(error);
    }, [error])

    return (
        <PhoneField
            { ...field }
            onChange={(value) => {
                if (typeof(value) === 'undefined') {
                    field.onChange('')
                }
                setValue(value);
            }}
            error={meta.error}
            {...rest}
        />
    )
};

export default FormikPhoneField;
